import * as React from "react"
import { observer } from "mobx-react-lite"
import { Text } from "../text/text"
import { View } from "native-base"
import { Appearance, StyleProp } from "react-native"
import { Image } from "../image/image"
import { ImageStyle, Source } from "react-native-fast-image"
import { IViewProps } from "native-base/lib/typescript/components/primitives/View"

const listEmpty = require('./list-empty.png')

export interface ListEmptyProps extends IViewProps {
  colorScheme?: "light"|"dark",
  source?: number | Source,
  text?: string
}

const IMAGE: StyleProp<ImageStyle> = {
  width: 151,
  height: 151
}

/**
 * Describe your component here
 */
export const ListEmpty = observer(function ListEmpty(props: ListEmptyProps) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    source = listEmpty,
    text,
    ...restProps
  } = props;

  return (
    <View flexGrow={1} alignItems="center" justifyContent="center" {...restProps}>
      <View padding="16px" alignItems="center">
        <View padding="16px" alignItems="center" justifyContent="center">
          <Image source={source} style={IMAGE} />
        </View>
        {text && <Text text={text} preset="title3" colorScheme={colorScheme} />}
      </View>
    </View>
  )
})
